import AbstractCommand from "../../../core/application/AbstractCommand";
import EmailInteractionEvent from "./EmailInteractionEvent"

export default class DraftEmailAvailableCommand extends AbstractCommand {
    constructor(dispatcher, emailModel, variableManager) {
        super(dispatcher);

        this.dispatcher = dispatcher;
        this.emailModel = emailModel;
        this.variableManager = variableManager;
    }

    execute(event) {
        this.content = event.params.data.content;
        this.contentPlayer = event.params.data.contentPlayer;

        // Ignore draft email as we are not using them.
        //this.emailModel.addEmail(this.content);
        this.onDraftMailSubmittedBound = this.onDraftMailSubmitted.bind(this);
        
        this.dispatcher.addEventListener(EmailInteractionEvent.SUBMIT_DRAFT, this.onDraftMailSubmittedBound);
    }

    onDraftMailSubmitted(event) {
        var item = event.params.item;
        if (item.content == this.content) {
            item.send();

            // Set variables based on player choice.
            let variables = item.content.getVariables();
            variables.forEach( (value, variable) => {
                this.variableManager.setVariable(variable, value);
            });

            this.dispatcher.removeEventListener(this.onDraftMailSubmittedBound);
            this.contentPlayer.contentCompleted(this.content);
        }
    }
}